export default "__VITE_ASSET__ec22a3d6__"